import { atom } from 'jotai';
import { $CurrentHashtagId } from './current-hashtag-id';
import { $HashtagInfo } from 'shared/atoms';
import { HashtagInfo } from 'shared/models';
import { TopicUtil } from 'shared/models/topic/topic-util';

export const $CurrentHashtagInfo = atom((get) => {
  const hashtagId = get($CurrentHashtagId);
  return get($HashtagInfo(hashtagId));
});

export const $CurrentAvailableHashtagInfoOrNull = atom<HashtagInfo | null>((get) => {
  const hashtag = get($CurrentHashtagInfo);
  if (TopicUtil.isTopicAvailable(hashtag)) {
    return hashtag;
  }
  return null;
});

export const $CurrentHashtagInfoAsAvailable = atom<HashtagInfo>((get) => {
  return get($CurrentHashtagInfo) as HashtagInfo;
});
